import { Availabilities } from "@/components/organisms/currentUserPresence/types";

export const mapPresenceToStatus = (availability: string) => {
	switch (availability) {
		case Availabilities.Available:
		case Availabilities.Online:
			return "available";   
		case Availabilities.Busy:
		case Availabilities.BusyIdle:
		case Availabilities.Offering:
		case Availabilities.Unavailable:
			return "busy";
		case Availabilities.AvailableIdle:
		case Availabilities.Away:
		case Availabilities.BeRightBack:
			return "away";
		case Availabilities.DND:
			return "do-not-disturb";
		case Availabilities.Offline:
		case Availabilities.PresenceUnknown:
		default:
			return "offline";
	}
};
